module.exports = __webpack_public_path__ + "img/keder_reinorange_ral2004.72d7d932.jpg";